module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-6.7b480c78.png";